import React from 'react';
import PropTypes from 'prop-types';

// Linha de campo dentro de um Panel: label à esquerda, valor à direita, fundo cinza clarinho.
// Uso: <FieldRow label="Status" value="Ativo" />
const FieldRow = ({ label, value }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'rgb(250, 250, 250)',
      borderRadius: 12,
      padding: '12px 16px',
      outline: '1px solid rgb(242, 242, 242)',
      outlineOffset: '-1px',
      wordBreak: 'break-word',
      marginBottom: 8,
    }}
  >
    <span style={{ color: '#6b6b6b', fontSize: '0.9em' }}>{label}</span>
    <span style={{ color: '#1a1a1a', fontSize: '1em', fontWeight: 500, textAlign: 'right' }}>
      {value}
    </span>
  </div>
);

FieldRow.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
};

export default FieldRow;
